
/* PRODUCT */
export const PRE_ADD_DATA = "PRE_ADD_DATA";
export const PRE_ADD_DATA_SUCCESS = "PRE_ADD_DATA_SUCCESS";
export const PRE_ADD_DATA_FAIL = "PRE_ADD_DATA_FAIL";

export const GET_PRODUCT_LISTING = "GET_PRODUCT_LISTING";
export const GET_PRODUCT_LISTING_SUCCESS = "GET_PRODUCT_LISTING_SUCCESS";
export const GET_PRODUCT_LISTING_FAIL = "GET_PRODUCT_LISTING_FAIL";

export const GET_PRODUCT_LISTING_FOR_GIFT = "GET_PRODUCT_LISTING_FOR_GIFT";
export const GET_PRODUCT_LISTING_FOR_GIFT_SUCCESS = "GET_PRODUCT_LISTING_FOR_GIFT_SUCCESS";
export const GET_PRODUCT_LISTING_FOR_GIFT_FAIL = "GET_PRODUCT_LISTING_FOR_GIFT_FAIL";

export const GET_PRODUCT_LISTING_FOR_ACCESORIES = "GET_PRODUCT_LISTING_FOR_ACCESORIES";
export const GET_PRODUCT_LISTING_FOR_ACCESORIES_SUCCESS = "GET_PRODUCT_LISTING_FOR_ACCESORIES_SUCCESS";
export const GET_PRODUCT_LISTING_FOR_ACCESORIES_FAIL = "GET_PRODUCT_LISTING_FOR_ACCESORIES_FAIL";

export const GET_PRODUCT_DETAILS = "GET_PRODUCT_DETAILS";
export const GET_PRODUCT_DETAILS_SUCCESS = "GET_PRODUCT_DETAILS_SUCCESS";
export const GET_PRODUCT_DETAILS_FAIL = "GET_PRODUCT_DETAILS_FAIL";

export const ADD_PRODUCT = "ADD_PRODUCT";
export const ADD_PRODUCT_SUCCESS = "ADD_PRODUCT_SUCCESS";
export const ADD_PRODUCT_FAIL = "ADD_PRODUCT_FAIL";

export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_FAIL = "UPDATE_PRODUCT_FAIL";

export const APPROVE_REJECT_PRODUCT = "APPROVE_REJECT_PRODUCT";
export const APPROVE_REJECT_PRODUCT_SUCCESS = "APPROVE_REJECT_PRODUCT_SUCCESS";
export const APPROVE_REJECT_PRODUCT_FAIL = "APPROVE_REJECT_PRODUCT_FAIL";

export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAIL = "DELETE_PRODUCT_FAIL";

export const DELETE_BULK_PRODUCT = "DELETE_BULK_PRODUCT";
export const DELETE_BULK_PRODUCT_SUCCESS = "DELETE_BULK_PRODUCT_SUCCESS";
export const DELETE_BULK_PRODUCT_FAIL = "DELETE_BULK_PRODUCT_FAIL";

export const EXPORT_PRODUCT = "EXPORT_PRODUCT";
export const EXPORT_PRODUCT_SUCCESS = "EXPORT_PRODUCT_SUCCESS";
export const EXPORT_PRODUCT_FAIL = "EXPORT_PRODUCT_FAIL";

export const IMPORT_PRODUCT = "IMPORT_PRODUCT";
export const IMPORT_PRODUCT_SUCCESS = "IMPORT_PRODUCT_SUCCESS";
export const IMPORT_PRODUCT_FAIL = "IMPORT_PRODUCT_FAIL";

export const IMPORT_PRODUCT_IMAGE = "IMPORT_PRODUCT_IMAGE";
export const IMPORT_PRODUCT_IMAGE_SUCCESS = "IMPORT_PRODUCT_IMAGE_SUCCESS";
export const IMPORT_PRODUCT_IMAGE_FAIL = "IMPORT_PRODUCT_IMAGE_FAIL";

export const RESET_PRODUCT_STATE = 'RESET_PRODUCT_STATE';
export const RESET_IMPORT_STATE = 'RESET_IMPORT_STATE';

export const BULK_ATTACH_PDF = "BULK_ATTACH_PDF";
export const BULK_ATTACH_PDF_SUCCESS = "BULK_ATTACH_PDF_SUCCESS";
export const BULK_ATTACH_PDF_FAIL = "BULK_ATTACH_PDF_FAIL";

export const BULK_UPDATE_PRODUCT_STATUS = "BULK_UPDATE_PRODUCT_STATUS";
export const BULK_UPDATE_PRODUCT_STATUS_SUCCESS = "BULK_UPDATE_PRODUCT_STATUS_SUCCESS";
export const BULK_UPDATE_PRODUCT_STATUS_FAIL = "BULK_UPDATE_PRODUCT_STATUS_FAIL";